// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--XQIM2","text":"_93444fe79c--text--Y0d0m"};